export const IconTimeClockCircle: {
  name: 'icon_time_clock_circle-54191b9c87f1'
} = {
  name: 'icon_time_clock_circle-54191b9c87f1'
}
